<template>
  <div>
    <base-card>
      <v-card-text>
        <div
          class="d-flex flex-column align-center justify-center text-center py-6"
        >
          <h3 class="mb-8">Actualizar Estado De Transacciones</h3>
        </div>
        <v-row justify="center">
          <v-dialog v-model="showModalAlert" max-width="450px" persistent>
            <v-card>
              <v-card-title class="headline">
                <v-spacer></v-spacer>
                <v-btn icon @click="showModalAlert = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="tx-center">
                <v-icon class="icon-warning"
                  color="gray"
                  >mdi mdi-alert-circle-outline</v-icon
                >
                <div class="mt-3">
                  <h6>¿Estás seguro de modificar los registros?</h6>
                  <v-text-field
                    v-model="reasonStatus"
                    label="Razón del cambio"
                    outlined
                    dense
                    required
                  />
                </div>
                <v-row justify="center" no-gutters class="mt-3">
                  <v-col cols="12" sm="6" class="text-sm-right">

                    <v-btn
                      class="ma-2"
                      style="background-color: rgb(204 33 40); color: white !important;"
                      @click.prevent="updateInvoices"
                      :disabled="!isReasonValid"
                      v-can="'Actualizar Estado Transacciones'"
                    >
                      <v-icon left>mdi mdi-thumb-up</v-icon>
                      Si
                    </v-btn>
                  </v-col>

                  <v-col cols="12" sm="6" class="text-sm-left">
                    <v-btn
                      class="ma-2"
                      color="gray"
                      @click="showModalAlert = false"
                    >
                      <v-icon left>mdi mdi-thumb-down-outline</v-icon>
                      No
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
        <v-form ref="form" v-model="formValid">
          <v-row justify="center">
            <v-col cols="auto" sm="4">
              <v-select
                ref="client"
                v-model="dataFilter.company"
                :items="filteredClients"
                item-text="text"
                item-value="company"
                label="Selecciona Una Compañía"
                prepend-inner-icon="mdi mdi-select-search"
                required
                dense
                outlined
                @change="fetchToken"
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-text-field
                          v-model="search"
                          placeholder="Buscar"
                          prepend-inner-icon="mdi-magnify"
                          hide-details
                          dense
                        />
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
              <div v-if="loadingToken"><em>Obteniendo token...</em></div>
            </v-col>

            <v-col cols="auto" sm="4">
              <v-textarea
                v-model="dataFilter.consecutive"
                label="Consecutivos (Separados Por Coma)"
                prepend-inner-icon="mdi-file-document"
                dense
                outlined
                required
                placeholder="Ej: FE123,FE124,FE130"
                rows="1"
                auto-grow
                :rules="consecutiveRules"
                :error-messages="errorMessages"
              />
            </v-col>
          </v-row>
        </v-form>

        <v-row justify="center" no-gutters>
          <v-col cols="12" sm="6" class="text-sm-right">
            <v-btn
              :disabled="isLoadingUpdate"
              :loading="isLoadingUpdate"
              class="ma-2"
              style="background-color: rgb(204 33 40); color: white !important"
              @click.prevent="showAlertUpdateInvoices"
              v-can="'Actualizar Estado Transacciones'"
            >
              <v-icon left>mdi mdi-invoice-text-remove-outline</v-icon>
              Actualizar Registros
            </v-btn>
          </v-col>

          <v-col cols="12" sm="6">
            <v-btn
              :disabled="loading && files.length === 0"
              class="ma-2"
              color="gray"
              @click="clearFields"
            >
              Limpiar
            </v-btn>
          </v-col>
        </v-row>
        <v-row justify="center" class="my-4">
          <v-progress-linear
            v-if="isLoadingUpdate"
            class="my-4"
            color="danger"
            indeterminate
          ></v-progress-linear>
          <v-col cols="12" sm="6">
            <v-alert
              v-if="showAlert"
              :type="alertType"
              dense
              outlined
              border="left"
              colored-border
              class="my-4"
            >
              {{ alertMessage }}
            </v-alert>
          </v-col>
        </v-row>

      </v-card-text>
    </base-card>
  </div>
</template>

<script>
import axios from "axios";
import { environment } from "@/data/environment";

export default {
  data() {
    return {
      detailClients: [],
      dataFilter: {
        company: null,
        consecutive: "",
      },
      reasonStatus: '',
      search: "",
      isLoadingUpdate: false,
      showAlert: false,
      alertMessage: "",
      alertType: "success",
      errorMessages: "",
      consecutiveRules: [
        (v) => !!v || "Este campo es requerido",
        (v) =>
          !v ||
          /^(?!,)([a-zA-Z0-9]+(,[a-zA-Z0-9]+)*)$/.test(v) ||
          "Solo se permiten letras, números y comas, sin iniciar ni terminar con coma",
      ],
      token: null,
      loadingToken: false,
      showModalAlert: false,
      formValid: false,
    };
  },
  mounted() {
    this.fetchCompanies();
  },
  computed: {
    filteredClients() {
      const query = this.search.toLowerCase();
      return this.detailClients.filter((c) =>
        c.text.toLowerCase().includes(query)
      );
    },
    isReasonValid() {
      return this.reasonStatus && this.reasonStatus.trim().length > 0
    }
  },
  methods: {
    async fetchCompanies() {
      try {
        const response = await axios.get(
          environment.HIOPOSWEBSERVICES + "/api/getClients"
        );
        this.detailClients = response.data.Mensaje.map((c) => ({
          text: " [ " + c.IdCompania + " ] " + c.NombreCompania,
          company: c,
        }));
      } catch (error) {
        console.error("Error al obtener compañías:", error);
      }
    },

    async updateInvoices() {
      this.resetAlert();
      const isValid = this.$refs.form.validate();

      if (!isValid) {
        this.showModalAlert = false
        this.setAlert(
          "error",
          "Por favor, complete todos los campos obligatorios o arregle los consecutivos."
        );
        return;
      }
      const arrayConsecutive = this.dataFilter.consecutive
        .split(",")
        .map((c) => c.trim())
        .filter(Boolean);

      this.isLoadingUpdate = true;
      this.showModalAlert = false;
      try {
        let user = JSON.parse(atob(localStorage.getItem('uid'))).user;

        const response = await axios.post(
          `${environment.HIOPOSWEBSERVICES}/api/updateStatusInvoices`,
          {
            company: this.dataFilter.company,
            arrayConsecutive,
            user: user,
            reasonStatus: this.reasonStatus

          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
          }
        );

        const data = response.data;

        if (data.error) {
          throw new Error("Respuesta inválida del servidor.")
        }

        this.setAlert("success", "Actualización de facturas Exitoso.");
        this.reasonStatus = '';
        this.clearFields();
      } catch (error) {
        console.error("Error al actualizar facturas:", error);
        this.setAlert("error", data.detail);
        this.reasonStatus = '';

      } finally {
        this.isLoadingUpdate = false;
      }
    },

    showAlertUpdateInvoices(){
      const arrayConsecutive = this.dataFilter.consecutive
        .split(",")
        .map((c) => c.trim())
        .filter(Boolean);

      if (!this.dataFilter.company) {
        this.setAlert("warning", "Por favor selecciona una compañía.");
      } else if (arrayConsecutive.length === 0) {
        this.setAlert("warning", "Por favor escribe al menos un consecutivo.");
      }else{
        this.showModalAlert = true;
      }
    },

    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },

    resetAlert() {
      this.alertMessage = "";
      this.alertType = "success";
      this.showAlert = false;
    },

    clearFields() {
      this.dataFilter = {
        company: null,
        consecutive: "",
      };
      this.search = "";
      this.token = null;

    },

    async fetchToken() {
      if (!this.dataFilter) return;

      this.token = null;
      this.loadingToken = true;

      try {
        const formData = new FormData();
        formData.append("TokenEnterprise", this.dataFilter.company.TokenEnterprise);
        formData.append("TokenPassword", this.dataFilter.company.TokenPassword);

        const response = await axios.post(
          environment.HIOPOSWEBSERVICES + "/api/login",
          formData
        );

        this.token = response.data.token;
      } catch (e) {
        alert("Error al obtener token");
        console.error(e);
      } finally {
        this.loadingToken = false;
      }
    },
  },
};
</script>
<style scoped>
.icon-warning {
  color: rgb(204 33 40);
  font-size: 100px;
}
.tx-center {
  text-align: center;
}
</style>
